import axios from "axios";
import { getBackendUrl } from "../config";

const normalizeBackendUrl = (url) => {
	if (!url) return url;
	const trimmed = String(url).trim();
	if (!trimmed) return "";

	if (/^https?:\/\//i.test(trimmed)) {
		return trimmed;
	}

	if (trimmed.startsWith("//")) {
		const protocol = typeof window !== "undefined" ? window.location.protocol : "https:";
		return `${protocol}${trimmed}`;
	}

	const protocol = typeof window !== "undefined" ? window.location.protocol : "https:";
	return `${protocol}//${trimmed}`;
};

const backendBaseUrl = normalizeBackendUrl(
	getBackendUrl() || process.env.REACT_APP_BACKEND_URL
);

const api = axios.create({
	baseURL: backendBaseUrl,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: backendBaseUrl
});

export default api;
